import API from "../api";

export const getUPI = () => API.get("/upi");
export const addUPI = (data) => API.post("/upi", data);
export const updateUPI = (id, data) => API.put(`/upi/${id}`, data);
export const deleteUPI = (id) => API.delete(`/upi/${id}`);
export const getPropinsi = () => API.get("/data/propinsi");
export const getKota = () => API.get("/data/kota");
